// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Greif Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";
/* Greif Custom Code - End */

const textArea: Styleguide["textArea"] = {
    /* Greif Custom Code - Start */
    defaultProps: {
        css: css`
            border-radius: ${pxToRem(4)} !important; /* This need to be overridable without !important */
        `,
    },
    /* Greif Custom Code - End */
};

export default textArea;
